import { isTrackingMobileApp } from '~domain/helper/quotes/mobile-app-tracking-helpers';
import { TranslatorFn } from '~domain/i18n';
import { carriersConfig } from '~domain/model/configs/carriers-config/carriers-config-facade';
import { Carrier } from '~domain/model/core/carrier';

export class CarrierHelper {
  static getDisplayName(carrier: Carrier, translator: { t: TranslatorFn }): string {
    return translator.t(`carriers.displayName.${carrier}`);
  }

  static getProductDisplayName(carrierCode: string, translator: { t: TranslatorFn }): string {
    const carrier = carriersConfig.getCarrierFromCode(carrierCode);

    if (isTrackingMobileApp(carrierCode)) {
      return translator.t(`carriers.mobileAppTracking.${carrier}`);
    }

    // For other carriers, we just use the carrier display name
    return this.getDisplayName(carrier, translator);
  }
}
